import { useQuery } from "@tanstack/react-query";

import { useGeotabClient } from "@/components/GeotabClientContext";
import { fetchUserStateRows, UserStateRow } from "@/utilities/addInData/userStateRecords";

export const userStateQueryKey = (activeSessionId: string | null, userId: string | undefined) =>
  ["userState", activeSessionId, userId] as const;

const NO_ROWS: UserStateRow[] = [];

export function useUserStateRows(): {
  rows: UserStateRow[];
  isReady: boolean;
  userId: string | undefined;
} {
  const { geotabClient, activeSessionId, me, meResolved } = useGeotabClient();
  // Until the current session's user is known there is no user to read or write for: `me` may be
  // loading or, right after a session switch, still the previous session's user.
  const userId = meResolved ? me?.id : undefined;

  const query = useQuery({
    queryKey: userStateQueryKey(activeSessionId, userId),
    queryFn: ({ signal }) => fetchUserStateRows(geotabClient, userId as string, signal),
    enabled: meResolved && !!userId,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

  return {
    rows: query.data?.rows ?? NO_ROWS,
    isReady: meResolved && (!userId || query.isFetched),
    userId,
  };
}
